import type { ArtifactListResponseItem } from "@/client";
import { artifactListItemUsesCsvFile } from "../../utils/artifactKindCatalog";
import { useArtifactKindsContext } from "../../utils/ArtifactKindsContext";
import "./ArtifactItemThumbnail.css";
import { MaterialSymbol } from "@ui/MaterialSymbol";
import { Show } from "solid-js";

export const ArtifactItemThumbnail = (props: {
	item: ArtifactListResponseItem;
	size?: "xsmall" | "small" | "medium";
	iconType?: "small" | "large";
}) => {
	const { displayKind } = useArtifactKindsContext();
	const isCsvFile = () => artifactListItemUsesCsvFile(props.item);
	const config = () =>
		displayKind(props.item.kind, { isCsvFile: isCsvFile() });

	const kindClass = () => (isCsvFile() ? "csv" : (props.item.kind ?? "other"));
	const sizeClass = props.size ?? "medium";
	return (
		<div
			class={`answer-item-thumbnail kind-${kindClass()} size-${sizeClass}`}
			style={{ "background-color": config().colour }}
		>
			<Show
				when={props.iconType === "small"}
				fallback={<MaterialSymbol symbol={config().icon} />}
			>
				<MaterialSymbol
					symbol={config().smallSymbol}
					relativeSize={0.75}
					filled
				/>
			</Show>
		</div>
	);
};
